import React, { useState } from "react";
import { mainMenu } from "./menuConstants";
import { Link } from "react-router-dom";
import history from "../../history";
import { createMedia } from "@artsy/fresnel";
import { useDispatch, useSelector } from "react-redux";
import { retrunToMol } from "../../views/Login/actions";
import { CLAIMS_BASE_API, getPolicyBLink } from "../../urlConstants";
import restUtils from "../../utils/restUtils";
import { Modal, ModalContent } from "semantic-ui-react";
 
// Media breakpoints
export const { MediaContextProvider, Media } = createMedia({
  breakpoints: {
    sm: 0,
    md: 768,
    lg: 1024,
    xl: 1192,
  },
});
 
 
const Flyout = () => {
  const currentPath = history.location.pathname;
  const [showMenu, setShowMenu] = useState(false);
  const [confirmPopup, setConfirmPopup] = useState({
    visible: false,
    url: "",
    isPolicyBredirect: false,
  });
  const { userName,storeId, storeguid, csr } = useSelector((state) => state.SessionReducer);
  const dispatch = useDispatch();
  const checkShowPopup = async () => {
    try {
      const res = await restUtils.getDataWithBearer(
        `${CLAIMS_BASE_API}/${storeId}/GetPendingClaimItemsGreaterthan48HRS?createdBy=${userName.replace("@","")}`
      );
      return res?.data;
    } catch (err) {
      console.error("Popup check API failed:", err);
      return 0;
    }
  };
  const handleMenuClick = async (
    url,
    isPolicyBredirect,
    isPolicyB = false
  ) => {
    const result = await checkShowPopup();
    if (result > 0 && currentPath === "/claimConfirmation" && url !== "/newClaim") {
      setConfirmPopup({ visible: true, url, isPolicyBredirect });
      return;
    }
    if (isPolicyB) {
      try {
        const res = await restUtils.getDataWithBearer(
          `${CLAIMS_BASE_API}/${storeId}/GetPolicyBClaimGuidToNavigate?userGuid=${storeguid}`
        );
        dispatch(
          retrunToMol(
            `${getPolicyBLink()}?guid=${res.data}&csr=${csr}&startpage=claimform`
          )
        );
      } catch (err) {
        console.error("PolicyB fetch failed:", err);
        setConfirmPopup({ visible: true, url, isPolicyBredirect: true });
      }
    }
    else {
      history.push(url);
    }
  };
 
  const confirmRedirect = async () => {
    if (confirmPopup.isPolicyBredirect) {
            try {
        const res = await restUtils.getDataWithBearer(
          `${CLAIMS_BASE_API}/${storeId}/GetPolicyBClaimGuidToNavigate?userGuid=${storeguid}`
        );
        dispatch(
          retrunToMol(
            `${getPolicyBLink()}?guid=${res.data}&csr=${csr}&startpage=claimform`
          )
        );
      } catch (err) {
        console.error("PolicyB confirm fetch failed:", err);
      }
    } else {
      history.push(confirmPopup.url);
    }
    setConfirmPopup({ visible: false, url: "", isPolicyBredirect: false });
  };

  const cancelRedirect = () => {
    setConfirmPopup({ visible: false, url: "", isPolicyBredirect: false });
  };

  const renderMenu = (menus) => {
    return menus.map((menu) => {
      const { key, title, url } = menu;
      const isPolicyB = key === "PolicyB";
      const requiresConfirmation = currentPath === "/claimConfirmation";
      return (
        <span
          className={
            currentPath === url ? "activeMenu customMenuLink" : "customMenuLink"
          }
          key={key}
          onClick={() => handleMenuClick(url,requiresConfirmation&&isPolicyB, isPolicyB)}
        >
          {title}
        </span>
      );
    });
  };
 
  return (
    <div className="mainMenuWrapper">
      <div className="gridContainer mobileMenuContainer">
        <MediaContextProvider>
          <Media at="sm">
            <div>
              {showMenu && (
                <span
                  className="backDropShadow"
                  onClick={() => setShowMenu(false)}
                ></span>
              )}
              <div
                className="mobileMenuIcon"
                onClick={() => setShowMenu(true)}
              >
                <i className="fas fa-bars"></i>
              </div>
            </div>
          </Media>
        </MediaContextProvider>
        <div className="navList" id={showMenu ? "showMenu" : ""}>
          <MediaContextProvider>
            <Media at="sm">
              <span
                className="closeMenu"
                onClick={() => setShowMenu(false)}
              >
                <i className="fas fa-times-square"></i>
              </span>
            </Media>
          </MediaContextProvider>
          {renderMenu(mainMenu)}
        </div>
      </div>
      {confirmPopup.visible && (
        <Modal className="deleteItemPopup" open={confirmPopup.visible}>
          <ModalContent>
            <h4>You have Pending Items that are not submitted yet. <br/> <br/>Are you sure you want to continue?</h4>
            <div>
              <button className="ui button" onClick={confirmRedirect}>
                Yes
              </button>
              <button className="ui button redBtn" onClick={cancelRedirect}>
                No
              </button>
            <h4>If No, Please select either "Yes Please reorder" or "No, I want credit" option</h4>
            </div>
          </ModalContent>
        </Modal>
      )}
    </div>
  );
};
 
export default Flyout;